module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "daySwitcher"
  }, [_c('div', {
    staticClass: "buttonLeft",
    on: {
      "click": function($event) {
        return _vm.$emit("setPreviousWeek")
      }
    }
  }, [_vm._v("<")]), _c('div', {
    staticClass: "currentDate"
  }, [_vm._v(_vm._s(_vm.getCurrentDate))]), _c('div', {
    staticClass: "buttonRight",
    on: {
      "click": function($event) {
        return _vm.$emit("setNextWeek")
      }
    }
  }, [_vm._v(">")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d6b87e4","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/catalog/card/components/tabs/schedule/components/schedulecalendar/DaySwitcher.vue
// module id = 761025a386e90122dc2f
// module chunks = 6